export default "__VITE_ASSET__BwcQo_ma__"